import React from "react";

import styles from "../../JobShiftPreStart/JobShiftPreStartView.module.css";

export default function EmergencyProcedureRichTextSection({ section, sectionNumber, fallbackName }) {
  const sectionName = section && section.display_name ? section.display_name : fallbackName;
  const html = section
    && section.data
    && section.data.content
    && typeof section.data.content.html === "string"
    ? section.data.content.html.trim()
    : "";

  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview} ${styles.EmergencyProcedureSectionNum}`}>
          {sectionNumber}
        </span>
        {sectionName}
      </div>
      <div className={styles.PreviewSectionBody}>
        {html ? (
          <div className={`${styles.PreviewRichText} preview-swms-v3-rich-text`} dangerouslySetInnerHTML={{ __html: html }} />
        ) : (
          <div className={styles.PreviewPadding}><p /></div>
        )}
      </div>
    </div>
  );
}
